// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children?: React.Node,
};

const StyledContainer = styled.div`
  font-family: InterRegular;

  // Margin
  margin-top: ${props => props.mt || props.my || props.ma || 0}px;
  margin-bottom: ${props => props.mb || props.my || props.ma || 0}px;
  margin-right: ${props => props.mr || props.mx || props.ma || 0}px;
  margin-left: ${props => props.ml || props.mx || props.ma || 0}px;

  // Padding
  padding-top: ${props => props.pt || props.py || props.pa || 0}px;
  padding-bottom: ${props => props.pb || props.py || props.pa || 0}px;
  padding-right: ${props => props.pr || props.px || props.pa || 0}px;
  padding-left: ${props => props.pl || props.px || props.pa || 0}px;
  
  // Display
  display: ${props => props.flex ? 'flex' : (props.display || 'block')};
  justify-content: ${props => props.centered ? 'center' : (props.justify || 'flex-start')};
  align-items: ${props => props.centered ? 'center' : (props.align || 'start')};
  flex-direction: ${props => props.flex || 'row'};

  // Background
  background-color: ${props => props.fill || 'transparent'};
  
  // Position
  z-index: ${props => props.zIndex || 1};
  position: ${props => props.absolute ? 'absolute' : (props.relative ? 'relative' : undefined)};
  top: ${props => `${props.top}px` || undefined};
  bottom: ${props => `${props.bottom}px` || undefined};
  left: ${props => `${props.left}px` || undefined};
  right: ${props => `${props.right}px` || undefined};

  // Height
  height: ${props => (props.full || props.fullheight) ? '100%' : (props.height || 'auto')};
  width: ${props => (props.full || props.fullwidth) ? '100%' : (props.width || 'auto')};

  // Border
  border-radius: ${props => props.radius || '0'}px;
  border-color: ${props => props.bordered ? '#000' : undefined};
  border-width: ${props => props.bordered ? '1px' : undefined};
  border-style: ${props => props.bordered ? 'solid' : undefined};

  // Overflow
  overflow: ${props => props.overflow || undefined};

  cursor: ${props => props.onClick ? 'pointer' : 'inherit'};
  
  // Pseudo classes
  :active { transform: ${props => props.activeTransform || undefined} };
  :hover {
    background-color: ${props => props.hoverFill ? props.hoverFill : undefined};
    transform: ${props => props.hoverTransform ? props.hoverTransform : undefined};
    border-color: ${props => props.hoverColor ? props.hoverColor : undefined};
    color: ${props => props.hoverColor ? props.hoverColor : undefined};
  }
  
  // Transitions
  transition: 100ms ease-in-out;
`;

// $FlowFixMe
export default React.forwardRef(function Container(props: TProps, ref?: React.ForwardedRef): React.Node {
  return (
    <StyledContainer {...props} ref={ref || null}>
      {props.children}
    </StyledContainer>
  );
});
